export const Movie_API_KEY = "6086de366ae2e3d65aee559127f9c789";
export const firebase_API_KEY = "AIzaSyDFoo8i1tejDHN0eHduKP9JuV889egPDJ8";

